export const GET_REGIONS_SECTOR_GENERAL_SETTINGS_REQUEST = 'GET_REGIONS_SECTOR_GENERAL_SETTINGS_REQUEST';
export const GET_REGIONS_SECTOR_GENERAL_SETTINGS_SUCCESS = 'GET_REGIONS_SECTOR_GENERAL_SETTINGS_SUCCESS';
export const GET_REGIONS_SECTOR_GENERAL_SETTINGS_FAILURE = 'GET_REGIONS_SECTOR_GENERAL_SETTINGS_FAILURE';
